import { toRef } from 'vue';
import { useCookie } from 'nuxt/app';

const MOBILE_APP_COOKIE_NAME = 'mobile_app';

export function useIsMobileApp() {
  const isMobileApp = useCookie(MOBILE_APP_COOKIE_NAME);
  return toRef(() => !!isMobileApp.value);
}
